import React, { useContext, useEffect, useState } from 'react';

import EmployeeUtilizationContext from '@totem/components/ticketing/employeeUtilization/employeeUtilizationContext';
import {
  TImeEntryReportFilterOptions,
  TImeEntryReportFilters,
} from '@totem/components/ticketing/employeeUtilization/models';
import TimeEntryReportTable from '@totem/components/ticketing/employeeUtilization/timeEntryReportTable';
import { TimeEntryReportItem } from '@totem/components/ticketing/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull } from '@totem/utilities/common';
import { TICKETS_ENDPOINT } from '@totem/utilities/endpoints';
type Props = {
  employee?: string;
};
const TimeEntryReport = ({ employee }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [reportData, setReportData] = useState<TimeEntryReportItem[]>([]);
  const [rawData, setRawData] = useState<TimeEntryReportItem[]>([]);
  const [filterOptions, setFilterOptions] =
    useState<TImeEntryReportFilterOptions>({
      organization: [],
      ticketNumber: [],
    });
  const [filter, setFilter] = useState<TImeEntryReportFilters>({
    billable: null,
    organization: [],
    ticketNumber: [],
  });
  const { input } = useContext(EmployeeUtilizationContext);
  const setInput = (updated: Partial<TImeEntryReportFilters>) => {
    setFilter({ ...filter, ...updated });
  };
  useEffect(() => {
    const organizations = rawData.map((item) => item.organization.name);
    const ticketNumbers = rawData.map((item) => item.ticket.number);
    const newFilterOptions: TImeEntryReportFilterOptions = {
      organization: [...new Set(organizations)],
      ticketNumber: [...new Set(ticketNumbers)],
    };
    setFilterOptions(newFilterOptions);
    let data = [...rawData];
    if (
      isNotNull(filter) &&
      isNotNull(filter.billable) &&
      filter.billable.length > 0
    ) {
      data = data.filter((item) =>
        filter.billable.includes(item.ticket.timeEntry.billable ? 'Yes' : 'No'),
      );
    }
    if (
      isNotNull(filter) &&
      isNotNull(filter.organization) &&
      filter.organization.length > 0
    ) {
      data = data.filter((item) =>
        filter.organization.includes(item.organization.name),
      );
    }
    if (
      isNotNull(filter) &&
      isNotNull(filter.ticketNumber) &&
      filter.ticketNumber.length > 0
    ) {
      data = data.filter((item) =>
        filter.ticketNumber.includes(item.ticket.number),
      );
    }
    setReportData(data);
  }, [rawData, filter]);

  useEffect(() => {
    const payload = {
      startTime: input.startTime,
      endTime: input.endTime,
    };
    const endpoint =
      isNotNull(employee) && employee !== ''
        ? `${TICKETS_ENDPOINT}/timeEntries/${employee}`
        : `${TICKETS_ENDPOINT}/timeEntries`;
    fetch(endpoint, {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((result: TimeEntryReportItem[]) => {
        setRawData(result);
      });
  }, [input.startTime, input.endTime, getApiToken]);
  return (
    <TimeEntryReportTable
      data={reportData}
      filterOptions={filterOptions}
      updateFilters={setInput}
      filters={filter}
    />
  );
};
export default TimeEntryReport;
